(function() {
  'use strict';
  // Directive for scrolling the menu on its own
  angular.module('ringbaPortal').directive('trSlimscroll', trSlimscroll);

  function trSlimscroll () {
    const directive = {
      restrict: 'A',
      link: link
    };
    return directive;

    function link($scope, $elem, $attr) {
      let off = [];
      let option = {};

      const refresh = function () {
        if ($attr.trSlimscroll) {
          option = $scope.$eval($attr.trSlimscroll);
        }
        $($elem).slimScroll({ destroy: true });
        $($elem).slimScroll(option);
      };

      const registerWatch = function () {
        if ($attr.trSlimscroll && !option.noWatch) {
          off.push($scope.$watchCollection($attr.trSlimscroll, refresh));
        }

        if ($attr.slimscrollDestroy) {
          off.push($scope.$watchCollection($attr.slimscrollDestroy, destroy));
        }
      };

      const destroy = function (newVal) {
        if (newVal) {
          $($elem).slimScroll({ destroy: true });
          $($elem).attr('style','');
        } else {
          refresh();
        }
      };

      const destructor = function () {
        $($elem).slimScroll({ destroy: true });
        off.forEach(function (unbind) {
          unbind();
        });
        off = null;
      };

      off.push($scope.$on('$destroy', destructor));

      registerWatch();
    }
  }
})();
